module.exports = __webpack_public_path__ + "static/img/banner2.5a68a201.png";